import { SelectedLocationContent } from "./SelectedLocationContent";

export default SelectedLocationContent;
